angular.module('unergie.main')
.filter('validationStatus', () =>
    function (val) {
        switch (val) {
            case 'UNAFFECTED':
                return 'Non renseigné'
            case 'AFFECTED':
                return 'Validé'
            case 'EXCLUDED':
                return 'Exclu du marché'
            default:
                return val
        }
    },
)
